<template>
  <div class="page">
    <div class="flex column h-center">
      <img src="./assets/no_robot.png"
           class="banner">
      <div class="remind">机器人已领取完！</div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Index',
  components: {},
  data () {
    return {
    }
  },
  computed: {},
  async created () {
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.page {
  background: #f6f6f6;
}
.banner {
  width: 146px;
  height: 127px;
  margin: 148px auto 0;
}
.remind {
  margin-top: 20px;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  color: #433c3c;
  line-height: 20px;
}
</style>
